import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const StateForm = (props) => {
  const [stateName, setStateName] = useState("");
  const [stateData, setStateData] = useState([]);

  const [countryId, setCountryId] = useState(0);

  const [stateInitial, setStateInitial] = useState("");

  const [countryData, setCountryData] = useState([]);

  const { sendRequest: poststateDetails } = useHttp();

  const { sendRequest: getstateData } = useHttp();

  const FillDetail = () => {
    getstateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setStateData(res);
          //  console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getstateData]);

  const { sendRequest: getCountry } = useHttp();
  useEffect(() => {
    getCountry(
      {
        url: `/api/countryList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setCountryData(data);
      }
    );
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();

    if (!props.update) {
      const isExistingState = stateData.some(
        (state) => state.stateName === stateName
      );

      const isExistingInitial = stateData.some(
        (item) => item.stateInitial === stateInitial
      );

      if (isExistingState) {
        toast.error("State name already exists");
        return;
      }
      if (isExistingInitial) {
        toast.error("Station initial already exists");
        return;
      }
    }

    const data = [{
      countryId: parseInt(countryId),
      stateName: stateName,
      stateInitial: stateInitial,

      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,

      ...(props.update && { stateId: props.update.stateId }), 
    }];

    // console.log("data", data);

 

    poststateDetails(
      {
        url: "/api/stateLocation/",
        method: props.update ? "PUT" : "POST",

        body: data,
      },
      (res) => {
        toast.success(`state Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    console.log(props.update);
    if (props.update) {
      setStateName(props.update.stateName);

      setCountryId(props.update.countryId);

      setStateInitial(props.update.stateInitial);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">State Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Country Name</label>
                        <select
                          id="countryId"
                          className="form-control"
                          required
                          value={countryId}
                          onChange={(e) => {
                            setCountryId(e.target.value);
                          }}
                        >
                          <option value="0">Select</option>
                          {countryData &&
                            countryData.map((x) => (
                              <option key={x.countryId} value={x.countryId}>
                                {x.countryName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>State Name</label>
                        <input
                          type={"text"}
                          id={"stateName"}
                          required
                          className="form-control"
                          value={stateName}
                          onChange={(e) => {
                            setStateName(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Station Initial </label>
                        <input
                          type={"text"}
                          id={"stateInitial"}
                          required
                          className="form-control"
                          value={stateInitial}
                          onChange={(e) => {
                            setStateInitial(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default StateForm;
